import HTMLString from 'react-html-string';
import React from 'react';

export default function CommonDescription(props) {
  const { data, title } = props;

  return (
    <article className='common-description'>
      {title && (<h2>{title}</h2>)}
      {data && <HTMLString html={data} />}
    </article>
  );
}